import React from 'react';
import type { Moment } from 'moment';
import { Textarea } from '@this/shared/ui/inputs/textarea';
import type SupportFeeElement from '@this/domain/support_fee_element/support_fee_element2';
import DatetimePicker from '@this/shared/datetime_picker/datetime_picker';
import { observer } from 'mobx-react';

interface Props {
  element: SupportFeeElement;
  classNameForModifiedField: (...path: (string | number)[]) => string;
}

const SupportFeeElementForm = ({ element, classNameForModifiedField }: Props) => (
  <>
    <div className="virtual-counte-price-change-form__input-wrapper">
      <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('content')}`}>
        内容
        <span className="red">（必須）</span>
      </label>
      <Textarea
        value={element.content}
        onChange={e => {
          element.content = e.target.value;
        }}
        rowsMin={1}
      />
    </div>
    <div className="virtual-counte-price-change-form__input-wrapper-item">
      <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('reservedAt')}`}>
        予約日
      </label>
      <DatetimePicker
        value={element.reservedAt}
        onChange={(time: Moment) => {
          element.reservedAt = time;
        }}
        showTime={false}
        disabledDays={0}
        showPast
      />
    </div>
  </>
);

export default observer(SupportFeeElementForm);
